import { Box, Typography } from "@mui/material"
import React from "react"
import { customPalette } from "../../../../../../../../theme"
import { BSVariantCreateButton } from "./BSVariantCreateButton"

export function BSVariantListNoComparison(): React.JSX.Element {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      gap={1}
      width="100%"
      height="100%">
      <Typography fontSize="24px" fontWeight={600} lineHeight="36px" color={customPalette.darkBlue3}>
        Il faut au moins 2 estimations
      </Typography>
      <Typography variant="body1" py={1} textAlign="center">
        Nous vous invitons à ajouter des estimations Beem Shot puis revenir ici pour les comparer.
      </Typography>
      <BSVariantCreateButton />
    </Box>
  )
}
